import React from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Box, Button, useTheme } from '@mui/material';

export type DossierProcessesFooterProps = {
    handleAddItem: () => void;
    handleMainAction?: () => void;
    addItemTextBtn?: string;
    canAddItem?: boolean;
    canHandleMainAction?: boolean;
    mainActionTextBtn?: string;
};

const DossierProcessesFooter: React.FunctionComponent<DossierProcessesFooterProps> = function ({
    handleAddItem,
    handleMainAction,
    addItemTextBtn = 'Ajouter',
    canAddItem = false,
    canHandleMainAction = false,
    mainActionTextBtn = 'Publier',
}) {
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            {canAddItem ? (
                <Button
                    onClick={handleAddItem}
                    sx={{
                        fontWeight: 500,
                        padding: '8px 20px',
                        display: 'flex',
                        columnGap: '4px',
                        alignItems: 'center',
                        color: palette.primary.dark,
                        ':hover': {
                            color: palette.primary.main,
                        },
                    }}
                    variant="text"
                    key="add-bodacc-btn"
                >
                    <FaOptionIcon
                        icon={['fas', 'plus']}
                        sx={{ lineHeight: 1, color: 'inherit' }}
                    />
                    {addItemTextBtn}
                </Button>
            ) : (
                <Box />
            )}

            {canHandleMainAction && handleMainAction && (
                <Button
                    onClick={handleMainAction}
                    sx={{
                        padding: '8px 20px',
                        fontSize: '16px',
                        background: palette.primary.dark,
                        ':hover': {
                            background: palette.primary.main,
                        },
                        transition: 'all ease-in-out 300ms',
                    }}
                    variant="contained"
                    key="publish-bodacc-btn"
                >
                    {mainActionTextBtn}
                </Button>
            )}
        </Box>
    );
};

export default DossierProcessesFooter;
